<template>
  <RevCard class="h-[fit-content] text-center md:col-span-1 lg:col-span-3">
    <ChartCircle class="m-auto h-[13rem] w-[13rem] p-16" :value>
      <span
        :class="`body-1-light absolute top-0 bottom-0 left-0 right-0 flex justify-center items-center text-[2.5rem]`"
      >
        {{ value }}%
      </span>
    </ChartCircle>
    <h3 class="heading-3 p-24 text-left md:p-32">
      {{ text }}
    </h3>
  </RevCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'

import translations from './ActivityReach.translations'

const props = defineProps<{
  value: number
}>()

const i18n = useI18n()

const text = computed(() => {
  const amount = props.value / 100

  return props.value < 100
    ? i18n(translations.inProgress, {
        amount,
      })
    : i18n(translations.complete, {
        amount,
      })
})
</script>
